<div class="managerUserComponent_container">
    <span class="managedUserComponent_formFieldContainer">
        <mat-form-field class="managerUserComponent_formField" [ngClass]="{'is-mobile-view': isMobileView}" appearance="outline">
            <mat-label>{{"moovView.userEntry" | translate}}</mat-label>
            <textarea matInput class="managerUserComponent_textInput" [(ngModel)]="userText" [readonly]="!inEditMode"></textarea>        
        </mat-form-field>
    </span>
    <span>
        <button *ngIf="!isDisabled" mat-mini-fab class="managedUserComponent_button" (click)="actionButtonClicked()"><mat-icon class="managerUserComponent_buttonIcon">{{buttonIconName}}</mat-icon></button>
    </span>    
</div>